/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import AsyncOpenHelpPanelLinkThroughEventListener from '@atlassian/jira-help-panel-button/src/async.tsx';
import AsyncLegacyTeamProfileCard from '@atlassian/jira-profilecard-next/src/ui/team-profilecard-legacy/async.tsx';
import type { RouteContext } from '@atlassian/react-resource-router';
import { LegacyPage } from '@jira/router-routes__common/src/ui/legacy-page/main.tsx';

type Props = RouteContext;

export const LegacyPageWithTeamProfileCardView = (props: Props): React.JSX.Element => (
	<>
		<LegacyPage {...props} />

		<AsyncOpenHelpPanelLinkThroughEventListener />

		<AsyncLegacyTeamProfileCard />
	</>
);
